import {AdminAxios, AdverAxios} from "../../common/Axios";

const ACTION_URL = '/adver/campaign'
const MEDIA_CATEGORY = '/list'
const MEDIA_SEARCH = '/media/inventory/by'
const MEDIA_SEARCH_ARRAY = '/media/inventory/array'
const CONFIG_INVENTORY = '/config/inventory'
const CONFIG_DEMOTARGET = '/config/demographic'
const GROUP_INFO = '/inventory'
const DEMO_INFO = '/demographic'
const SYSTEM_CAMPAIGN_URL = '/adver/campaign'
const SYSTEM_REGION_URL = '/system/regions'

export async function selMediaCategoryInfo() {
  let returnVal = null;
  await AdminAxios('GET', ACTION_URL + '/MEDIA_CATEGORY' + MEDIA_CATEGORY)
  .then((response) => {
    const { data, statusCode } = response;
    if (statusCode === 200) {
      returnVal = data;
    } else {
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

export async function selSearchMediaInfo(keyword) {
  let returnVal = null;
  await AdminAxios('GET', MEDIA_SEARCH + '?keyword=' + keyword)
  .then((response) => {
    const { data, statusCode } = response;
    if (statusCode === 200) {
      returnVal = data;
    } else {
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

export async function selSearchMediaList(inventoryIds) {
  let returnVal = null;
  if (inventoryIds.inventoryIds === undefined) {
    return null;
  }
  await AdminAxios('POST', MEDIA_SEARCH_ARRAY, inventoryIds)
  .then((response) => {
    const { data, statusCode } = response;
    if (statusCode === 200) {
      returnVal = data;
    } else {
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

export async function updateCampaignConfigInventory(campaignGroupInfo) {
  let returnVal = null;
  await AdminAxios('PUT',
      ACTION_URL + '/' + campaignGroupInfo.campaignId + CONFIG_INVENTORY,
      campaignGroupInfo)
  .then((response) => {
    const {statusCode} = response
    if (statusCode === 200) {
      returnVal = true
    } else {
      returnVal = false
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};
export async function updateCampaignDemographicTarget(campaignDemoInfo) {
  let returnVal = null;
  await AdminAxios('PUT',
      ACTION_URL + '/' + campaignDemoInfo.campaignId + CONFIG_DEMOTARGET,
      campaignDemoInfo)
  .then((response) => {
    const {statusCode} = response
    if (statusCode === 200) {
      returnVal = true
    } else {
      returnVal = false
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

export async function selGroupInfo(campaignId) {
  let returnVal = null;
  await AdminAxios('GET', ACTION_URL + '/' + campaignId + GROUP_INFO)
  .then((response) => {
    const { data, statusCode } = response;
    if (statusCode === 200) {
      returnVal = data;
    } else {
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};
export async function selCampaignDemographicTarget(campaignId) {
  let returnVal = null;
  await AdminAxios('GET', ACTION_URL + '/' + campaignId + DEMO_INFO)
  .then((response) => {
    const { data, statusCode } = response;
    if (statusCode === 200) {
      returnVal = data;
    } else {
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

async function retrieveRegionList(uri) {
  let returnVal = null;
  await AdverAxios('GET', uri)
  .then((response) => {
    const {data, statusCode} = response;
    returnVal = statusCode === 200 ? data ?? [] : null;
  }).catch(() => returnVal = false);
  return returnVal;
}

export function selAdministrativeCountries() {
  return retrieveRegionList(SYSTEM_REGION_URL + '/countries');
}

export function selAdministrativeCities(countryCode) {
  return retrieveRegionList(
      SYSTEM_REGION_URL + '/cities?countryCode=' + encodeURIComponent(countryCode)
  );
}

export function selAdministrativeRegions(cityCode) {
  return retrieveRegionList(
      SYSTEM_REGION_URL + '?cityCode=' + encodeURIComponent(cityCode)
  );
}

export async function selCampaignRegionTarget(campaignId) {
  return retrieveCampaignRegionList(SYSTEM_CAMPAIGN_URL + '/' + campaignId + '/region');
}

async function retrieveCampaignRegionList(uri) {
  let returnVal = null;
  await AdminAxios('GET', uri)
  .then((response) => {
    const {data, statusCode} = response;
    returnVal = statusCode === 200 ? data ?? [] : null;
  }).catch(() => returnVal = false);
  return returnVal;
}

export async function updateCampaignRegionTarget(campaignRegionInfo) {
  let returnVal = null;
  await AdminAxios(
      'PUT',
      SYSTEM_CAMPAIGN_URL + '/' + campaignRegionInfo.campaignId + '/config/region',
      {
        regionTargetConfigType: campaignRegionInfo.regionTargetConfigType,
        regionCodes: campaignRegionInfo.regionCodes
      }
  ).then((response) => {
    returnVal = response?.statusCode === 200;
  }).catch(() => returnVal = false);
  return returnVal;
}

